export default __webpack_public_path__ + "static/media/icon-pin-red.251b982f.svg";